import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private router: Router) { }


  get locale() {
    var language = localStorage.getItem('locale');
    return language;
  }

  set locale(cd: string) {
    localStorage.setItem('locale', cd);
  }

  changeLanguage(languageCd: string) {
    var newUrl = '/' + languageCd + '' + this.router.url;
    this.locale = languageCd;
    if (!this.router.url || this.router.url == "/") {
      var path = '';
      var routes = this.router.config.filter(x => window.location.pathname.indexOf(x.path) > -1 && x.path)
      //if url is not on the general routes. Look under client routes
      if (routes.length == 0) {
        routes = this.router.config.filter(x => x.path == 'client/:clientId')[0].children.filter(x => window.location.href.indexOf(x.path) > -1 && x.path)
      }
      if (routes.length > 0) {
        path = routes[0].path
        newUrl = '/' + languageCd + '/' + path;
      }
    }
    if (window) {
      window.location.href = newUrl;
    }
  }
}
